// extracted by mini-css-extract-plugin
export var width100 = "C_w d_w";
export var design3Pos = "C_vq d_0";